

















































































































































































import './style.css';
// import './print.css';
// import './prettyPhoto.css'
// import './custom'
import {getInfoByKeyword, createQrcode} from '@/api/resume'

import {Component, Prop, Vue} from 'vue-property-decorator'

@Component({
    props: {
        user: Object,
        works: Object,
        education: Array,
        skill: Array,
        company: Array,
        honor: Array,
        qrcode: String
    }
})

export default class Preview extends Vue {
    @Prop() private user?: Record<string, any>;
    @Prop() private works?: Record<string, any>;
    @Prop() private education?: Record<string, any>;

    // 数据
    @Prop() private skill?: Record<string, any>;
    @Prop() private company?: Record<string, any>;
    @Prop() private honor?: Record<string, any>;
    @Prop() private qrcode?: string;

    data() {
        return {
            user: {
                code: "",
                name: "张易",
                phone: "110",
                describe: "5",
                sex: false,
                status: "离职",
                age: "13",
                photo: "7",
                email: "zy8338719@hotmail.com",
                wechat: "murphyyi",
                github: "https://github.com/zy84338719",
                native: "北京",
                city: "北京",
                keyword: "w",
                watch: 20,
                expect: "后端研发",
                year: 8
            },
            education: [{
                school: "江苏科技大学",
                formal: "本科学历",
                start: 2015,
                end: 2019,
                job: "计算机科学与技术"
            }],
            works: [{
                name: "超级玛丽",
                url: "http://murphyyi.oss-cn-beijing.aliyuncs.com/1.png",
                photo: "http://murphyyi.oss-cn-beijing.aliyuncs.com/1.png"
            }
            ],
            skill: [
                {
                    name: "",
                    sequence: 1,
                    percentage: 70
                }
            ],
            company: [
                {
                    info: {
                        "code": "",
                        "company_name": "",
                        "company_code": ""
                    },
                    event: null
                }
            ],
            honor: [
                {
                    "code": "w",
                    "name": "网易云课堂  获得python数据分析师 微专业优秀证书",
                    "url": "https://murphyyi.oss-cn-beijing.aliyuncs.com/%E7%BD%91%E6%98%93%E4%BA%91%E8%AF%BE%E5%A0%82.jpg"
                },
            ],
            qrcode: "",
        }
    }

    // // 计算属性
    // computed: {}
    //     // 侦听器
    //     | undefined
    // // 侦听器
    // watch: {}
    //     // 生命周期钩子
    //     | undefined
    //
    // 生命周期钩子
    // beforeCreate() {
    // },
    //
    // // eslint-disable-next-line @typescript-eslint/no-empty-function
    // created() {
    //     (this as any).getInfo()
    // }

    //
    // // eslint-disable-next-line @typescript-eslint/no-empty-function
    // beforeMount() {
    // }
    //
    // // eslint-disable-next-line @typescript-eslint/no-empty-function
    mounted() {
        this.getInfo()
        this.getQrcode()
    }

    //
    // // eslint-disable-next-line @typescript-eslint/no-empty-function
    // beforeUpdate() {
    // }
    //
    // // eslint-disable-next-line @typescript-eslint/no-empty-function
    // updated() {
    // }
    //
    // // eslint-disable-next-line @typescript-eslint/no-empty-function
    // activated() {
    // }
    //
    // // eslint-disable-next-line @typescript-eslint/no-empty-function
    // deactivated() {
    // }
    //
    // // eslint-disable-next-line @typescript-eslint/no-empty-function
    // beforeDestroy() {
    // }
    //
    // // eslint-disable-next-line @typescript-eslint/no-empty-function
    // destroyed() {
    // }

    // 事件处理方法

    getInfo(): void {
        const {keyword} = this.$route.params;
        getInfoByKeyword({keyword}).then(
            (data: Data) => {
                this.user = data.user
                this.works = data.works
                this.education = data.education
                this.skill = data.skill
                this.company = data.company
                this.honor = data.honor
            }
        )
    }

    getQrcode(): void {
        const {keyword} = this.$route.params;
        // let url = "http://localhost:10080/"+keyword

        createQrcode({keyword: window.location.href}).then((data: string) => {

            this.qrcode = "data:image/png;base64," + data
        })
    }

}
